import _Array$isArray from '@babel/runtime-corejs3/core-js-stable/array/is-array';
import { invariant } from '../../../../../@react-dnd/invariant/dist/esm/d3abb5e672e7778a38d58eaa2ecad8bcd52c0adee27175788c7c8d2b86512d43.cfe-internal.js';
import { useMemo } from 'react';

/**
 * Internal utility hook to get an array-version of spec.accept.
 * The main utility here is that we aren't creating a new array on every render if a non-array spec.accept is passed in.
 * @param spec
 */
function useAccept(spec) {
  var accept = spec.accept;
  return useMemo(function () {
    invariant(spec.accept != null, 'accept must be defined');
    return _Array$isArray(accept) ? accept : [accept];
  }, [accept]);
}

export { useAccept };
